import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ADD_PARTICIPANT, ADD_ROW, ConvertRole, ConvertStatus, DELETE_ROW, DROPDOWN_LIST_NONE, 
   JSON_KEY_CODE, JSON_KEY_FIRM, 
   JSON_KEY_LOGIN_ATTEMPTS, JSON_KEY_DESCRIPTION, JSON_KEY_ROLE, JSON_KEY_STATUS, 
   UPDATE_ROW, SET_ROLE_AND_MC, JSON_KEY_CONNECTION_STATUS,
   TABLE_HEADER_CONNECTION_STATUS, JSON_KEY_SERVER_CONNECTION, TABLE_HEADER_SERVER_CONNECTION,
   ConvertConnectionStatus,
   AddItemToDropdown,
   NAME_MARKET_CONTROLLER,
   NAME_SUPER_CONTROLLER,
   NAME_FIRMMANAGER,
   NAME_TRADER,
   TABLE_HEADER_FORCE_PASSWORD_CHANGE,
   JSON_KEY_FORCE_PASSWORD_CHANGE,
   TABLE_HEADER_COORDINATOR,
   JSON_KEY_COORDINATOR,
   TABLE_HEADER_TR_DELETE_REDUNDANT_ORDERS,
   JSON_KEY_TR_DELETE_REDUNDANT_ORDERS,
   BIT_MASK_ORDER_REQUEST,
   BIT_MASK_HOLDINGS_REQUEST,
   NAME_MARKET_CONTROLLER_VIEWER,
   NAME_SUPER_CONTROLLER_PERFORMANCE,
   NAME_MARKET_CONTROLLER_PERFORMANCE,
   NAME_MARKET_CONTROLLER_VIEWER_PERFORMANCE,
   TABLE_HEADER_CODE,
   TABLE_HEADER_DESCRIPTION,
   TABLE_HEADER_FIRM,
   TABLE_HEADER_ROLE,
   TABLE_HEADER_STATUS,
   TABLE_HEADER_LOGIN_ATTEMPTS,
   HasPermission,
   JSON_KEY_PERMISSION,
   TABLE_HEADER_PERMISSION,
   BIT_MASK_TRADE_REQUEST,
   TABLE_HEADER_CHECKPOINTER,
   JSON_KEY_CHECKPOINTER,
   NAME_DATAFEED_SERVER,
   NAME_TRANSACTION_SERVER,
   TABLE_HEADER_BACKUP,
   JSON_KEY_BACKUP,
   NAME_ALL_IN_ONE_SERVER,
   BIT_MASK_ORDER_PAIR,
   NAME_TRADING_OPERATOR,
   TABLE_HEADER_LISTENING_PORT,
   JSON_KEY_LISTENING_PORT,
   TABLE_HEADER_PROMETHEUS_PORT,
   JSON_KEY_PROMETHEUS_PORT,
   instrumentCodeColor,
   rowOpacityForStatus,
   statusTextColor}
   from '../../common/common';
import { Modal } from 'react-bootstrap';
import UsersAdminForm from '../forms/users_admin_form';
import { selectIsMarketController, selectTSUserId, setHoldingsRequest, setIsMarketController, setOrdersRequest, setOrderPair, setRoleId, setTradesRequest, setUsersLoaded } from '../../redux/globalsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { addTradingUsers, addEngineUsers, selectEngineUsers } from '../../redux/dropDownSlice';
import { ConvertToTradingRulesValueName } from '../../common/convert_functions';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';

const Users2 = () => {
   const dispatch = useDispatch();
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const [dropDownUserData, setDropDownUserData] = useState([]);
   const dropDownEngineUserData = useSelector(selectEngineUsers);
   const [dropDownFirmData, setDropDownFirmData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const tsUserId = useSelector(selectTSUserId);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   
   // ✅ FIX: Queue for actions that need to be dispatched outside of render
   // start of changes
   // const pendingActionsRef = useRef([]);
   
   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);

   // ✅ FIX: Process pending actions in useEffect
   // useEffect(() => {
   //    // console.log('[UsersTable] Processing pending actions, count:', pendingActionsRef.current.length);
   //    if (pendingActionsRef.current.length > 0) {
   //       const actions = [...pendingActionsRef.current];
   //       pendingActionsRef.current = [];
         
   //       actions.forEach(action => {
   //          if (action.type === SET_ROLE_AND_MC) {
   //             console.log('users1, role :', action.data.role);   
   //             dispatch(setRoleId(action.data.role));
   //             dispatch(setIsMarketController(
   //                (action.data.role === NAME_SUPER_CONTROLLER) || 
   //                (action.data.role === NAME_MARKET_CONTROLLER) ||
   //                (action.data.role === NAME_MARKET_CONTROLLER_VIEWER) ||
   //                (action.data.role === NAME_SUPER_CONTROLLER_PERFORMANCE) || 
   //                (action.data.role === NAME_MARKET_CONTROLLER_PERFORMANCE) ||
   //                (action.data.role === NAME_MARKET_CONTROLLER_VIEWER_PERFORMANCE)
   //             ));
   //             dispatch(setOrdersRequest((action.data.perm & BIT_MASK_ORDER_REQUEST)));
   //             dispatch(setTradesRequest((action.data.perm & BIT_MASK_HOLDINGS_REQUEST)));
   //             dispatch(setHoldingsRequest((action.data.perm & BIT_MASK_HOLDINGS_REQUEST)));
   //             dispatch(setUsersLoaded(true));
   //          }
   //       });
   //    }
   // }, [dispatch]);

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[UsersTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[UsersTable] Row Double Clicked:`, rowData, ', isMarketController:', isMarketControllerRef.current);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);

   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };
   
   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log(`[UsersTable] Event:`, details);
      if (!details || !details.type || !details.data) {
         console.warn(`[UsersTable] Malformed event:`, details);
         return;
      }
   
      const { role, status, back, code, force_pwd, coord, check, dro } = details.data;
      const newRow = {
         ...details.data,
         id: code,
         role: ConvertRole(role),
         status: ConvertStatus(status),
         force_pwd: ConvertToTradingRulesValueName(force_pwd), 
         coord: ConvertToTradingRulesValueName(coord), 
         back: ConvertToTradingRulesValueName(back), 
         check: ConvertToTradingRulesValueName(check), 
         dro: ConvertToTradingRulesValueName(dro), 
         c_status: ConvertConnectionStatus(details.data.c_status),
      };
   
      switch (details.type) {
         case ADD_ROW:
            setLocalTableData(prevData => {
               const exists = prevData.some(row => row.id === code);
               if (exists) {
                  console.log("Existing row, data: ", details.data);
                  return prevData;
               }
               return [...prevData, newRow];
            });
            
            // ✅ Process immediately after state update
            // console.log('users2, code: ', code, ', role :', newRow.role, ', perm: ', details.data.perm, ', tsUserIdRef.current', tsUserIdRef.current);   
            if (code === tsUserIdRef.current) {
               // to logon with extra info on login return
               // dispatch(setRoleId(newRow.role));
               // dispatch(setIsMarketController(
               //    (newRow.role === NAME_SUPER_CONTROLLER) || 
               //    (newRow.role === NAME_MARKET_CONTROLLER) ||
               //    (newRow.role === NAME_MARKET_CONTROLLER_VIEWER) ||
               //    (newRow.role === NAME_SUPER_CONTROLLER_PERFORMANCE) || 
               //    (newRow.role === NAME_MARKET_CONTROLLER_PERFORMANCE) ||
               //    (newRow.role === NAME_MARKET_CONTROLLER_VIEWER_PERFORMANCE)
               // ));
               dispatch(setOrdersRequest(HasPermission(details.data.perm, BIT_MASK_ORDER_REQUEST)));
               dispatch(setOrderPair(HasPermission(details.data.perm, BIT_MASK_ORDER_PAIR)));
               dispatch(setTradesRequest(HasPermission(details.data.perm, BIT_MASK_TRADE_REQUEST)));
               dispatch(setHoldingsRequest(HasPermission(details.data.perm, BIT_MASK_HOLDINGS_REQUEST)));

               dispatch(setUsersLoaded(true));
            }

            AddItemToDropdown(setDropDownUserData, { id: details.data.code, name: details.data.code });

            if ((newRow.role === NAME_TRADER) || (newRow.role === NAME_FIRMMANAGER)) {
               dispatch(addTradingUsers({ id: newRow.code, name: newRow.code }));
            }

            if ((newRow.role === NAME_DATAFEED_SERVER) || (newRow.role === NAME_TRANSACTION_SERVER) || (newRow.role === NAME_ALL_IN_ONE_SERVER)) {
               dispatch(addEngineUsers({ id: newRow.code, name: newRow.code }));
            }

            break;
   
         case UPDATE_ROW:
            setLocalTableData(prevData => prevData.map(row => row.id === code ? newRow : row));
            break;
   
         case DELETE_ROW:
            setLocalTableData(prevData => prevData.filter(row => row.code !== details.data.code));
            break;
   
         case ADD_PARTICIPANT:
            AddItemToDropdown(setDropDownFirmData, { id: details.data.code, name: details.data.code });
            break;
   
         case SET_ROLE_AND_MC:
            // ✅ FIX: Queue this action instead of dispatching immediately
            // console.log('users3, role :', details.data.role);   
            dispatch(setRoleId(details.data.role));
            dispatch(setIsMarketController(
               (details.data.role === NAME_SUPER_CONTROLLER) || 
               (details.data.role === NAME_TRADING_OPERATOR) || 
               (details.data.role === NAME_MARKET_CONTROLLER) ||
               (details.data.role === NAME_MARKET_CONTROLLER_VIEWER) ||
               (details.data.role === NAME_SUPER_CONTROLLER_PERFORMANCE) || 
               (details.data.role === NAME_MARKET_CONTROLLER_PERFORMANCE) ||
               (details.data.role === NAME_MARKET_CONTROLLER_VIEWER_PERFORMANCE)
            ));
            dispatch(setOrdersRequest(HasPermission(details.data.perm, BIT_MASK_ORDER_REQUEST)));
            // dispatch(setOrderPair(HasPermission(details.data.perm, BIT_MASK_ORDER_PAIR)));
            dispatch(setTradesRequest(HasPermission(details.data.perm, BIT_MASK_TRADE_REQUEST)));
            dispatch(setHoldingsRequest(HasPermission(details.data.perm, BIT_MASK_HOLDINGS_REQUEST)));
            
            dispatch(setUsersLoaded(true));
            break;
            
         default:
            console.log('users handle events break, shouldn\'t be here');
            break;
      }
   }, [dispatch]); // ✅ Added dispatch to dependencies
   
   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_CODE] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);

   const columns = useMemo(() => [
      { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
      { Header: TABLE_HEADER_FIRM, accessor: JSON_KEY_FIRM },
      { Header: TABLE_HEADER_ROLE, accessor: JSON_KEY_ROLE, minWidth: 50, maxWidth: 350 },
      { Header: TABLE_HEADER_SERVER_CONNECTION, accessor: JSON_KEY_SERVER_CONNECTION },
      { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
      { Header: TABLE_HEADER_CONNECTION_STATUS, accessor: JSON_KEY_CONNECTION_STATUS },
      { Header: TABLE_HEADER_LOGIN_ATTEMPTS, accessor: JSON_KEY_LOGIN_ATTEMPTS },
      { Header: TABLE_HEADER_FORCE_PASSWORD_CHANGE, accessor: JSON_KEY_FORCE_PASSWORD_CHANGE },
      { Header: TABLE_HEADER_TR_DELETE_REDUNDANT_ORDERS, accessor: JSON_KEY_TR_DELETE_REDUNDANT_ORDERS },
      { Header: TABLE_HEADER_PERMISSION, accessor: JSON_KEY_PERMISSION },
      { Header: TABLE_HEADER_COORDINATOR, accessor: JSON_KEY_COORDINATOR },
      { Header: TABLE_HEADER_BACKUP, accessor: JSON_KEY_BACKUP },
      { Header: TABLE_HEADER_CHECKPOINTER, accessor: JSON_KEY_CHECKPOINTER },
      { Header: TABLE_HEADER_LISTENING_PORT, accessor: JSON_KEY_LISTENING_PORT },
      { Header: TABLE_HEADER_PROMETHEUS_PORT, accessor: JSON_KEY_PROMETHEUS_PORT }
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="UsersTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            enableSearch={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}
         />

         <Modal show={showForm} onHide={handleCloseForm}>
            <UsersAdminForm rowData={selectedRow} onClose={handleCloseForm} userOptions={dropDownUserData} firmOptions={dropDownFirmData} engineUsersOptions={dropDownEngineUserData} />
         </Modal>
      </>
   );
};

export default Users2;